var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pb-move_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 996",
    transform: "translate(1592 100)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1592 -100)",
    clipPath: "url(#pb-move_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18756"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1618.783 116l-.531-.571-7.936-8.513-1.316 1.144 7.406 7.94-7.406 7.941 1.316 1.144 7.936-8.513z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 995",
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M1597 115h20v2h-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1597.5 115.5h19v1h-19z"
  }))))));
}

export default __webpack_public_path__ + "ed3e534ea227690e127e5e5db5bbd8e7.svg";
export { SvgPbMove as ReactComponent };